import React from 'react';
import './topbar-user.css';

interface AppTopbarUserProps {
  className?: string;
}

export function AppTopbarUser({ className }: AppTopbarUserProps) {
  const userClass = ['topbar-user', className].filter(Boolean).join(' ');

  return (
    <div className={userClass}>
      {/* The avatar alone, as the 2026 rebrand mockups draw it: a prussian
          circle with lucide's `User` glyph. The name is in the menu it opens. */}
      <div className="topbar-user__avatar">
        <svg
          className="topbar-user__icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
        >
          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      </div>
    </div>
  );
}
